// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// ProductRole — source: shared/config/product_catalog.config.json § product_role

export const PRODUCT_ROLE_VALUES = ["sell", "buy", "both"] as const;
export type ProductRole = (typeof PRODUCT_ROLE_VALUES)[number];

export const productRoleColor: Record<ProductRole, string> = {
  "sell": "green",
  "buy": "blue",
  "both": "gray",
};

export const productRoleIcon: Record<ProductRole, string> = {
  "sell": "Tag",
  "buy": "ShoppingCart",
  "both": "ArrowLeftRight",
};

